import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const CHAT_HEADER_HEIGHT = 60;

export const ChatBoxContainer = styled(Box).attrs({
  width: '100%',
  height: `calc(100% - ${CHAT_HEADER_HEIGHT}px)`,
  flex: '1 1 auto',
})``;

export const Container = styled(Box)``;

export const ChatWrapper = styled(Box)`
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 5px;
  flex: 1 1 auto;
  height: 100%;
  min-height: ${CHAT_HEADER_HEIGHT + 2}px; // 2px accounts for the border
`;
